import styled from 'styled-components';
export const FormBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    column-gap: 15px;
    margin-bottom: 15px;
    @media screen and (max-width:767px) { 
        flex-wrap:wrap;
        gap:15px;
    }
    .form-group { 
        width: 100%;

        .input-group {
            background: #FFFFFF;
            box-shadow: 0px 10px 20px #0000000F; 
            border-radius: 8px;

            input {
                background: transparent;
                border: none;
                padding: 14px 12px 14px 20px;
                color: #333333;
                font-family: "Jost", sans-serif;
                font-size: 20px;
                font-weight: 400;
                line-height: 20px;
                border-radius: 8px;
                @media screen and (max-width:991px) { 
                    padding: 14px 6px 14px 6px;
                }  
            }
            .input-group-text {
                background: transparent;
                border: none;
            }
        }
    }
        .email-suggestion {
        color: #FF3131;
        font-size: 12px;
        font-weight: 500;
        cursor:pointer;
    strong{
     color:#33A7AE;
    }
}
`;
export const FormSubmitBtn = styled.div`
    max-width: 340px;
    width: 100%;
    margin: 20px auto 0;

    button{
        box-shadow: 0px 3px 20px #0000001A;
        width: 100%;
        padding: 13px;
        position: relative;
    }

 



`;